import { render, staticRenderFns } from "./inventoryList.vue?vue&type=template&id=647b9550&scoped=true"
import script from "./inventoryList.vue?vue&type=script&lang=js"
export * from "./inventoryList.vue?vue&type=script&lang=js"
import style0 from "./inventoryList.vue?vue&type=style&index=0&id=647b9550&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647b9550",
  null
  
)

export default component.exports